import { FC, useState } from 'react';
import styled from 'styled-components';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
} from '@mui/material';
import { blockConversation, HeroConversation } from '@vs-online-only-app/state';
import { Close } from '@mui/icons-material';

const CloseButton = styled(IconButton)`
  position: absolute;
  top: ${({ theme }) => theme.spacing(1)};
  right: ${({ theme }) => theme.spacing(1.5)};
`;

type Props = {
  onClose: () => void;
  conversation: HeroConversation;
};

const BlockUserConfirmationModal: FC<Props> = ({ onClose, conversation }) => {
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const confirmBlock = async () => {
    setIsLoading(true);
    setError(null);
    try {
      await blockConversation({ conversationId: conversation.id });
    } catch (error) {
      console.error('Error blocking conversation', error);
      setError('Error blocking conversation');
    }
    setIsLoading(false);
  };

  return (
    <Dialog open onClose={onClose}>
      <CloseButton onClick={onClose}>
        <Close />
      </CloseButton>
      <DialogTitle>Are you sure?</DialogTitle>
      <Divider />
      {error && <Alert severity="error">{error}</Alert>}
      <DialogContent>
        <DialogContentText>
          {conversation.conversationStarter.firstName} will no longer have the
          option to chat.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" fullWidth onClick={onClose}>
          Cancel
        </Button>
        <Button fullWidth onClick={confirmBlock} variant="contained">
          {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Block'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BlockUserConfirmationModal;
